import { useLocation, useNavigate } from 'react-router-dom';

import { ErrorBoundary } from '@/components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ErrorBoundaryWithRouter = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  return <ErrorBoundary {...props} location={location} navigate={navigate} />;
};
